<template>
  <div class="firebase-notification">
    <transition-group name="list" tag="div">
      <div v-for="notification in firebaseNotifications" :key="notification.id" class="">
        <v-alert
          color="#fbd929"
          icon="mdi-bell"
          elevation="10"
          class="pa-8 black--text position-relative"
          style="color: black"
        >
          {{ notification.lang ? $t(notification.lang) : notification.text }}
        </v-alert>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('alert', ['firebaseNotifications']),
  },
};
</script>

<style lang="scss">
.firebase-notification {
  position: fixed;
  z-index: 235;
  top: 30px;
  right: 30px;
  .v-alert__icon {
    color: black !important;
  }
}

.list-enter-active {
  animation: slideInRight;
  animation-duration: 0.3s;
}
.list-leave-active {
  animation: slideOutRight;
  animation-duration: 0.3s;
}
</style>
